import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import s from "./RadioChip.module.css";

export interface RadioChipProps extends InputHTMLAttributes<HTMLInputElement> {
  children: ReactNode;
}

/** A radio group option styled as a plain label chip — no radio glyph, just
    the label filling solid when checked. `ToggleChip`'s exact sibling for
    single-choice: a real `<input type="radio">`, not a `<button
    aria-pressed>`, so a screen reader hears "one of two" rather than
    "pressed" and native radio-group keyboard behaviour (arrow-key exclusive
    selection) comes for free. Hidden with a clip rect rather than `display:
    none`, so it stays in the tab order and inside a focus trap. Wrap a
    group of these in a `<div role="radiogroup" aria-labelledby={...}>`. */
export const RadioChip = forwardRef<HTMLInputElement, RadioChipProps>(function RadioChip(
  { children, className, type: _type, ...rest },
  ref,
) {
  const classes = className ? `${s.root} ${className}` : s.root;
  return (
    <label className={classes}>
      <input ref={ref} type="radio" className={s.input} {...rest} />
      <span className={s.text}>{children}</span>
    </label>
  );
});
